import { useEffect } from 'react';

import { UPDATE_TIME_SHIFT_TIMEOUT } from '../constants';
import commonStore from '../store/CommonStore';

export const useDateTimeSync = (): void => {
  useEffect(() => {
    if (!commonStore.backgroundMode) {
      commonStore.updateTimeShift();

      const interval = setInterval(
        commonStore.updateTimeShift,
        UPDATE_TIME_SHIFT_TIMEOUT,
      );
      return () => clearInterval(interval);
    }
  }, [commonStore.backgroundMode]);
};
